export default class ColumnMeta {
    constructor(name, type, title, description, width, precision, scale, nullable, unique, primary_key) {
        this.name = name;
        this.type = type;
        this.title = title;
        this.description = description;
        this.width = width;
        this.precision = precision;
        this.scale = scale;
        this.nullable = nullable;
        this.unique = unique;
        this.primary_key = primary_key;
    }
}
//# sourceMappingURL=ColumnMeta.js.map